import {FileUpload} from 'epic-fortnite-react';
import {Alert, Inline, Stack, Text} from 'epic-fortnite-react';
import {useField} from 'formik';
import React from 'react';
import {FileRejection} from 'react-dropzone';

import {SubmitIslandPageData} from '../types';

interface Props {
  name: string;
  submissionIdentifier: string;
  description?: string;
  tertiaryLabel?: string;
  label?: string;
  disabled?: boolean;
  type: 'image' | 'video';
  translations: SubmitIslandPageData;
}

type Status = 'UNITIALIZED' | 'READY' | 'UPLOADING' | 'UPLOADED';

export const FormikFileUpload = ({
  submissionIdentifier,
  description,
  tertiaryLabel,
  label,
  disabled,
  type,
  name,
  translations,
}: Props) => {
  const [field, , helpers] = useField<File>(name);
  const [state, setState] = React.useState<{
    file: File | undefined;
    status: Status;
    rejected?: FileRejection[];
  }>({
    file: undefined,
    status: 'UNITIALIZED',
    rejected: undefined,
  });

  return (
    <Stack gap="sm">
      <FileUpload
        id={name}
        description={description}
        tertiaryLabel={tertiaryLabel}
        label={label}
        name={name}
        onBlur={field.onBlur}
        onDropAccepted={(files) => {
          console.log('>> onDropAccepted', files);
          setState({file: files[0], status: 'READY'});
          helpers.setValue(files[0]);
          helpers.setTouched(true);
        }}
        onDropRejected={(files) => {
          console.log('>> onDropRejected', files);
          helpers.setTouched(true);
          setState((prevState) => ({...prevState, rejected: files}));
        }}
        disabled={disabled}
        type={type}
        translations={translations}
      />
      {state.rejected?.map(({file, errors}) => {
        return (
          <React.Fragment key={file.name}>
            {errors.map((e) => (
              <Alert key={e.code} tone="critical">
                {(function () {
                  switch (e.code) {
                    case 'file-invalid-type':
                      switch (type) {
                        case 'video':
                          return (
                            translations.submissionForm?.validationMessages
                              ?.videoRequirementsCodecMessage ?? e.message
                          );
                        case 'image':
                          return (
                            translations.submissionForm?.validationMessages?.imageFileTypeMessage ??
                            e.message
                          );
                        default:
                          return e.message;
                      }
                    default:
                      return e.message;
                  }
                })()}
              </Alert>
            ))}
          </React.Fragment>
        );
      })}
      {state.file && (
        <Inline flex="start" gap="sm">
          {state.file?.name && (
            <Text font="OpenSans" size="sm">
              {state.file.name}
            </Text>
          )}
          {/* {state.status === 'UPLOADED' ? (
            <IslandFormButton label="Uploaded!" disabled={true} />
          ) : (
            <IslandFormButton
              label="Upload"
              disabled={disabled || state.status !== 'READY'}
              onClick={async () => {
                const res = await upload(state.file, submissionIdentifier);
                if (res) {
                  setState({...state, status: 'UPLOADED'});
                  helpers.setValue(true);
                }
              }}
            />
          )} */}
        </Inline>
      )}
    </Stack>
  );
};
